const MIN_SENDS = 100;
const pct = (n, d) => (d > 0 ? n / d : 0);

const reportsFindings = ({
  rangeDays = 0,
  tab = "",
  totals = undefined,
  rows = [],
  actions = {}
} = {}) => {
  const out = [];
  if (rangeDays > 0 && rangeDays < 7) {
    out.push({
      tone: "neutral",
      key: "short_window",
      label: "Window too short to judge",
      text: `${rangeDays} days is noise for reply rates. Look at 30.`,
      actions: actions.widen ? [{ label: "Use 30 days", run: actions.widen }] : []
    });
  }

  const sent = totals?.emailsSentCount || 0;
  if (totals && sent >= MIN_SENDS) {
    const replyRate = pct(totals.emailsReplyCount, sent);
    const openRate = pct(totals.emailsOpenCount, sent);
    const bounceRate = pct(totals.emailsBounceCount, sent);
    const list = Array.isArray(rows) ? rows : [];

    if (replyRate >= 0.03) {
      const best = [...list].sort(
        (a, b) => pct(b.emailsReplyCount, b.emailsSentCount) - pct(a.emailsReplyCount, a.emailsSentCount)
      )[0];
      out.push({
        tone: "good",
        key: "at_benchmark",
        label: "At benchmark or above",
        text: `${(replyRate * 100).toFixed(1)}% replies. For US cold outbound 2-3% is good; you are above it.`,
        actions: actions.showBestSequence ? [{ label: "Show best sequence", run: () => actions.showBestSequence(best) }] : []
      });
    }

    if (openRate >= 0.4 && replyRate < 0.02) {
      out.push({
        tone: "warn",
        key: "read_not_answered",
        label: "Read, not answered",
        text: `People open (${(openRate * 100).toFixed(1)}%) but do not reply (${(replyRate * 100).toFixed(1)}%). The copy, not the subject.`,
        actions: actions.weakestCopy ? [{ label: "Which copy is weakest?", run: actions.weakestCopy }] : []
      });
    }

    if (bounceRate >= 0.04) {
      out.push({
        tone: "bad",
        key: "deliverability_drift",
        label: "Deliverability drift",
        text: `${(bounceRate * 100).toFixed(1)}% bounces account-wide. Check bounce sources before sending more.`,
        actions: actions.showBounceSources ? [{ label: "Show bounce sources", run: actions.showBounceSources }] : []
      });
    }

    const dragging = list.find(
      r =>
        (r.emailsSentCount || 0) >= MIN_SENDS &&
        replyRate - pct(r.emailsReplyCount, r.emailsSentCount) >= 0.02
    );
    if (dragging) {
      const rowRate = pct(dragging.emailsReplyCount, dragging.emailsSentCount);
      out.push({
        tone: "warn",
        key: "sequence_dragging",
        label: `${dragging.name} is dragging the average`,
        text: `${(rowRate * 100).toFixed(1)}% vs ${(replyRate * 100).toFixed(1)}% account-wide.`,
        actions: actions.openSequence ? [{ label: "Open that sequence", run: () => actions.openSequence(dragging) }] : []
      });
    }
  }

  if (tab) {
    out.push({
      tone: "neutral",
      key: "explain_change",
      label: "Explain a change",
      text: "Ask why a number moved and I will say what drove it, not just repeat it.",
      actions: actions.explainChange ? [{ label: "Explain a change", run: actions.explainChange }] : []
    });
    out.push({
      tone: "neutral",
      key: "weekly_digest",
      label: "Weekly digest",
      text: "A five-line summary of this report you can paste to your manager.",
      actions: actions.weeklyDigest ? [{ label: "Weekly digest", run: actions.weeklyDigest }] : []
    });
  }
  return out;
};

export default reportsFindings;
